export default {
  methods: {
    showResult (type, title, data = {}) {
      this.$MessageBox.show(type, {
        title,
        data
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/eventMixin.js